module.exports = __webpack_public_path__ + "static/media/Home.10f48b26.mp4";